export const DIVIDER = 1000000;
export const DEFAULT_AVATAR = 'https://hic.af/logo.png';
export const DISCORD_URL = 'https://discord.gg/Nq32af56Ka';
export const TWITTER_URL = 'https://twitter.com/hic_af';
export const HEN_URL = 'https://hen.hic.af';
export const audioPlayerHeight = 80;
